<template>
    <div class="wrapper">

        <div class="padding-sm bg-white flex-sub">

            <div class="flex align-center justify-between margin-bottom">
                <div class="flex align-center justify-between  list-search">
                    <el-select v-model="level" class="margin-right-sm flex-shrink" placeholder="请选择分支机构等级">
                        <el-option
                            v-for="item in levelList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input v-model="keyWord" placeholder="请输入分支机构名称"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
                </div>
            </div>
            <div class="ship-list">
                <el-table
                    v-loading="loading"
                    :data="lists" border
                    header-row-class-name="table-header"
                    style="width: 100%; border-radius: 10px">
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.$index + 1 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="分支机构名称" prop="company" width="220px">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.name }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="分支机构等级" prop="rankname" width="220px">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.rankname || '--' }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="联系人" prop="name">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.lianxiren }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="手机号" prop="phone">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.lianxidianhua }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="flex justify-center  align-center">
                                <el-button class="table-operate" @click="itemDetail(scope.row.id)">查看</el-button>
                                <el-button v-if="scope.row.is_check === 0" class="table-operate"
                                           @click="itemDetail(scope.row.id)">审核
                                </el-button>
                                <el-button v-if="scope.row.is_check === 2" class="table-operate line"
                                           @click="itemDetail(scope.row.id)">已拒绝
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all margin-top"
                layout="prev, pager, next, jumper"
                @current-change="listOrgFenHui">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {getCheckListFh, getRankList} from "@/api/organiz";

export default {
    name: "orgExam",
    data() {
        return {
            keyWord: '',
            lists: [],
            page: 1,
            limit: 15,
            total: 0,
            loading: false,
            levelList: [{
                id: 0,
                name: "全部"
            }],
            level: '',
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        fileData() {
            return {
                mid: this.user.mid,
                sign: this.user.sign,
            }
        }
    },
    created() {
        this.$emit('setIndex', [8, 2], '分支机构审核')
        this.listOrgFenHui()
        this.getRankList()
    },
    components: {},
    methods: {
        // 获取等级
        async listOrgFenHui() {
            this.loading = true
            let _list = await getCheckListFh(this.level, this.keyWord, this.page, this.limit)
            this.lists = _list.data
            this.total = _list.count
            this.loading = false
        },
        itemDetail(id) {
            this.$router.push(`/organization/members/orgExamInfo/${id}`)
        },
        search() {
            this.page = 1
            this.listOrgFenHui()
        },
        //  获取等级列表
        async getRankList() {
            let _list = await getRankList(2)
            this.levelList = [...this.levelList, ..._list.data]
        }
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.wrapper {
    .min-height {
        min-height: 930px;
    }

    .classifys {
        margin-bottom: 20px;

        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;
            color: #ffb400;
            border-radius: 0 6px 6px 0;

            &.active {
                background: #ffb400;
                color: #FFFFFF;
                border-radius: 6px 0 0 6px;
            }
        }
    }

    .member-set {
        div {
            width: 171px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            background-color: #f3f7fb;
            border-radius: 10px;
            border: solid 1px #dae0e6;
            font-size: 18px;
            cursor: pointer;

            &:hover {
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#0a2240, #0a2240);
                background-blend-mode: normal, normal;
                color: #fff;
            }
        }
    }

    .list-search {
        .el-button {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background: #0a2240;
            border: 0;
            font-size: 16px;
        }
    }

    .table-name {
        font-size: 14px;
        color: #333333;
        text-align: center;

        &.gray {
            color: #999999;
        }
    }

    .table-operate {
        width: 60px;
        height: 30px;
        padding: 0;
        border-radius: 15px;
        background-color: #0a2240;
        border: solid 1px #0a2240;
        font-size: 14px;
        color: #ffffff;

        &.line {
            background-color: #ffffff;
            color: #0a2240;
        }

        &:disabled {
            background-color: #ffffff;
            border: solid 1px #dae0e6;
            color: #bcc6cf;
        }
    }
}
</style>
